<template>
  <div class="element-preview">
    <component :is="preview" :component="component" class="preview-component" />

    <div class="options-buttons d-none d-lg-flex" v-if="editing">
      <bp-button
        size="sm"
        :label="`Editar ${type}`"
        color="neutral"
        icon="fa-regular fa-crop"
        @click="$emit('edit')"
      />
      <bp-button
        size="sm"
        :label="`Excluir ${type}`"
        color="negative"
        icon="fa-regular fa-trash"
        @click="$emit('remove')"
      />
    </div>

    <bp-options-menu
      v-if="editing"
      class="options-menu d-lg-none"
      :options="options"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import ImagePreview from "./ImagePreview.vue";
import TextPreview from "./TextPreview.vue";
import TimerPreview from "./TimerPreview.vue";
import VideoPreview from "./VideoPreview.vue";
export default {
  props: {
    component: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapState("checkoutBuilder", ["editing"]),
    preview() {
      if (!this.component) return;
      const previews = {
        image: ImagePreview,
        video: VideoPreview,
        text: TextPreview,
        timer: TimerPreview
      };
      return previews[this.component.type];
    },
    type() {
      const types = {
        image: "Imagem",
        video: "Vídeo",
        text: "Texto",
        timer: "Cronômetro"
      };
      return types[this.component.type];
    },
    options() {
      return [
        {
          label: `Editar ${this.type}`,
          icon: "fa-regular fa-crop",
          click: () => this.$emit("edit")
        },
        {
          label: `Excluir ${this.type}`,
          class: "text-negative-600",
          icon: "fa-regular fa-trash",
          click: () => this.$emit("remove")
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.element-preview {
  position: relative;

  .preview-component {
    border-radius: 4px;
    overflow: hidden;
  }

  .options-buttons {
    inset: 0;
    gap: 0.5rem;
    opacity: 0;
    z-index: -1;
    padding: 1rem 0;
    flex-wrap: wrap;
    position: absolute;
    border-radius: 4px;
    align-items: center;
    justify-content: center;

    transition: 0.2s all;
  }

  &:hover {
    .options-buttons {
      z-index: 1;
      opacity: 1;
      backdrop-filter: blur(6px);
      background: var(--Surface-Transparent-16, rgba(252, 252, 253, 0.92));
    }
  }

  .options-menu {
    position: absolute;
    top: 4px;
    right: 4px;
  }
}
</style>
